import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XrefApiKeyModalComponent } from './xref-api-key-modal.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@xref/xref-lib';


@NgModule({
  declarations: [XrefApiKeyModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule
  ]
})
export class XrefApiKeyModalModule { }
